var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-data-table',{staticClass:"elevation-2",attrs:{"headers":_vm.headerFields,"items":_vm.tareas,"no-data-text":_vm.gnodata,"dense":"","items-per-page":10},scopedSlots:_vm._u([{key:"item.fechamodificacion",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.formato(item.fechamodificacion)))]}},{key:"item.idusuarioresponsable",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.usuario(item.idusuarioresponsable)))]}},{key:"item.observacion",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.cambiarenter(item.observacion))}})]}},{key:"item.idestado",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',[_c('v-icon',_vm._g({staticClass:"mr-2",attrs:{"large":"","color":_vm.color(item)}},on),[_vm._v("info")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.estado(item)))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }